// Staging API endpoints. Per the auth doc, staging shares the prod Cognito
// pool but uses `api.staging.plunk.io` as the API base.

const HOST = 'api.staging.plunk.io';
const BASE = `https://${HOST}`;
export default {
  root: `${BASE}/v1/activity`,
  protocol: 'https',
  host: HOST,
  path: '/v1/activity',
  port: 443,
  activity: {
    root: `${BASE}/v1/activity`,
    protocol: 'https',
    host: HOST,
    path: '/v1/activity',
    port: 443
  },
  audience: {
    root: `${BASE}/v1`,
    protocol: 'https',
    host: HOST,
    path: '/v1',
    port: 443
  },
  product: {
    root: `${BASE}/v1`,
    protocol: 'https',
    host: HOST,
    path: '/v1',
    port: 443
  },
  location: {
    root: `${BASE}/v1`,
    protocol: 'https',
    host: HOST,
    path: '/v1',
    port: 443
  },
  forecast: {
    root: `${BASE}/v1`,
    protocol: 'https',
    host: HOST,
    path: '/v1',
    port: 443
  },
  assistant: {
    root: `${BASE}/v1`,
    protocol: 'https',
    host: HOST,
    path: '/v1',
    port: 443
  },
  campaign: {
    root: 'https://campaign.plunk.io/api',
    protocol: 'https',
    host: 'campaign.plunk.io',
    path: '/api',
    port: 443
  },
  research: {
    root: `${BASE}/v1/market-research`,
    protocol: 'https',
    host: HOST,
    path: '/v1/market-research',
    port: 443
  },
  marketIntelligence: {
    root: `${BASE}/v1/market-intelligence`,
    protocol: 'https',
    host: HOST,
    path: '/v1/market-intelligence',
    port: 443
  },
  agent: {
    root: `${BASE}/v1/agent`,
    protocol: 'https',
    host: HOST,
    path: '/v1/agent',
    port: 443
  }
};